/**
 * `apiFetch` wirft bei einer Nicht-2xx-Antwort einen Error mit der Meldung
 * `HTTP <status>: <body>` (siehe apps/web/src/utils/apiFetch.ts). `<body>` ist
 * bei unseren NestJS-Endpoints meist JSON der Form `{ message, error,
 * statusCode }` — `message` ist ein deutscher, nutzertauglicher Service-Text
 * (String) oder — bei class-validator-Fehlern — ein Array von Strings.
 *
 * Diese Funktion holt genau diesen Text heraus, statt das rohe
 * "HTTP 400: {...}" ungefiltert anzuzeigen. Klappt das Parsen nicht (kein
 * JSON, kein `message`-Feld, kein Error-Objekt), kommt der übergebene
 * Fallback-Text zurück.
 */
export function fehlerText(e: unknown, fallback: string): string {
  if (!(e instanceof Error)) return fallback;

  const treffer = /^HTTP \d+: ([\s\S]*)$/.exec(e.message);
  if (!treffer) return fallback;

  try {
    const body = JSON.parse(treffer[1]) as { message?: unknown };
    if (typeof body.message === "string" && body.message.trim()) return body.message;
    if (Array.isArray(body.message) && typeof body.message[0] === "string" && body.message[0].trim()) {
      return body.message[0];
    }
  } catch {
    /* kein JSON — Fallback greift */
  }
  return fallback;
}
